import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";
import { purgeOffline } from "./offline";

const Ctx = createContext(null);

export function PortalAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null); // null=checking, false=guest, obj=customer
  useEffect(() => {
    if (!window.location.pathname.startsWith("/portal")) { setCustomer(false); return; }
    api.get("/portal/me").then((r) => setCustomer(r.data)).catch(() => setCustomer(false));
  }, []);
  const login = async (identifier, password, remember = false) => {
    const r = await api.post("/portal/login", { identifier, password, remember });
    setCustomer(r.data);
    return r.data;
  };
  const logout = async () => {
    try { await api.post("/portal/logout"); } catch {}
    await purgeOffline();
    setCustomer(false);
  };
  return <Ctx.Provider value={{ customer, login, logout }}>{children}</Ctx.Provider>;
}

export const usePortalAuth = () => useContext(Ctx);
